export const ThankYouCopy = {

  defaultSuccessButtonText: 'See what your money does',
  defaultSuccessButtonUrl: 'https://www.comicrelief.com/what-your-money-does/',

  aarnOptedInHeader: 'Need an extra plushie?',
  aarnOptedInCopy: 'If you would like to purchase extra plushie toys, whether for yourself, your family or your friends, these can be purchased on our shop below.',

  aarnOptedOutHeader: 'Changed your mind? Plushies await!',
  aarnOptedOutCopy: "Chose to opt out of the postal benefits? No worries, it's not too late to bring a plushie home! Whether for yourself, your family or your friends, our exclusive plushies are just a click away...",

  // Goes via a CRcom redirect for quick updating, adding tracking strings, etc.
  ctaLink: 'https://www.comicrelief.com/parker-the-plushie/',
  ctaCopy: 'Shop now'
};
